<template>
    <modal @close="modeResetAugmentations">
        <template slot="header_title">
            Suppression
        </template>
        <template slot="main">
            <div class="main_update_augment">
                <strong>Voulez-vous vraiment effacer définitivement ces éléments ?</strong>
                <br>Impossible d’annuler cette opération.
            </div>
        </template>
        <template slot="footer">
            <v-layout row wrap>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_red" @click="modeResetAugmentations">
                        <i class="fas fa-times fa-btn" />
                        <span v-if="!isMobile">Annuler</span>
                    </v-btn>
                </v-flex>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_blue" @click="localDeleteAugment">
                        <i class="fa fa-check" />
                        <span v-if="!isMobile">Supprimer</span>
                    </v-btn>
                </v-flex>
            </v-layout>
        </template>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'ModalDeleteAugmentation',
        components: {
            modal: () => import('../../global/modal')
        },
        computed: {
            ...mapGetters('app', ['isMobile'])
        },
        methods: {
            ...mapActions('augmentations', ['deleteAugments', 'modeResetAugmentations']),
            ...mapActions('app', ['showOverlay', 'hideOverlay']),
            localDeleteAugment: function () {
                this.showOverlay();
                this.deleteAugments().then(() => {
                    this.hideOverlay();
                    this.modeResetAugmentations();
                    this.$toasted.success('Suppression de(s) augmentation(s) avec succés');
                }).catch((err) => {
                    this.hideOverlay();
                    this.modeResetAugmentations();
                    this.$toasted.error(err);
                });
            }
        }
    };
</script>

<style scoped>
    .main_update_augment {
        padding: 20px;
    }

    .modal-card-foot > .layout {
        margin: 0 !important;
    }
</style>
